/**
 *
 * .sticky_top
 */

var scrollLimit = 70,
    scrollcheck_interval = 50,
    interior_menu = 420,
    bottom_offset = 400,
    _scroll_offset = 150,
    didScroll = false,
    sticky_top_offset = 0;
    previous = 0; // scroll limit

module.exports = {
  init: function($) {
    'use strict';

    /*
     * assign 'scrolled' class when the user scrolls more than scroll limit
     */
    var _scrolled = function () {
        var _document_scrolltop = $(document).scrollTop();

        // Check if the person has scrolled
        if( _document_scrolltop > scrollLimit ) {
                $('body').addClass('scrolled');
                // scroll direction
                if( previous > _document_scrolltop ) {
                  //Scrolled Up
                  $('body').addClass('scrolledup');
                } else {
                  $('body').removeClass('scrolledup');
                }
                previous = _document_scrolltop;
            } else {
                $('body').removeClass('scrolled');
            }
            
        // Check for the interior menu scroll offset
        if( _document_scrolltop > interior_menu ) {
          $('body').addClass('interior_menu_stick');
        } else {
          $('body').removeClass('interior_menu_stick');
        }

        // Check if the user scrolled to the near bottom
        if(_document_scrolltop + $(window).outerHeight() > $(document).outerHeight() - bottom_offset) {
           $('body').addClass('at-the-bottom');
            } else {
                $('body').removeClass('at-the-bottom');
        }

    // Check if element has hit the top
    $('.check_in_screen').each( function() {
          var $this = $(this);
          console.log($(window).scrollTop() - ( $(window).height() / 2 ) + ':'+$this.position().top);
          // Make it sure to use 'position()' instead of offset() since, the element will be fixed which will lost offset value with the class
          if ( $(window).scrollTop() - ( $(window).height() / 2 ) >= $this.position().top ) {
              $this.addClass('in_screen');
          } else {
              $this.removeClass('in_screen');
          }
      });

    // Check if element has hit the top
    $('.sticky_top').each( function() {
          var $this = $(this);
          console.log($(window).scrollTop() + sticky_top_offset+':'+$this.position().top);
          // Make it sure to use 'position()' instead of offset() since, the element will be fixed which will lost offset value with the class
          if ( $(window).scrollTop() + sticky_top_offset >= $this.position().top ) {
              $this.addClass('sticked');
          } else {
              $this.removeClass('sticked');
          }
        });
    };

    $('.scrolltoprimary, #slider_logo').on('click',function(e) {
        e.preventDefault();
        $('body,html').animate({scrollTop:$('#primary').offset().top-64});
    });

    $('a.goto_onthispage').on('click', function(e) {
      e.preventDefault();
      var _scroll_to = 0;
      _scroll_to = $( $(this).attr('href') ).offset().top;
      _scroll_to -= _scroll_offset;
      $('html, body').animate({
              scrollTop: _scroll_to + 'px'
          }, 'fast');
    });

    $(window).on('load', function() {
      _scrolled(); // Check once in the beginning
    });

    $(window).on('scroll', function() {
        didScroll = true;
    });

    setInterval(function() {
        if ( didScroll ) {
            didScroll = false;
            _scrolled();
        }
    },
     scrollcheck_interval );

  }
};
